import React, { useContext, useState, useEffect , useRef } from 'react';
import { Paper, Box, Grid, Avatar, Chip, Switch, FormControlLabel, Typography, InputAdornment, CircularProgress, MenuItem, TextField, IconButton, Pagination , Checkbox } from '@mui/material';
import ApiService from '../../functions/apiService';
import moment from "moment";
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import Modal from 'react-bootstrap/Modal';
import { Link } from "react-router-dom";
import MyTable from '../../components/Schedule/MyTable';
import SearchIcon from "@mui/icons-material/Search";
// import ChecklistCard from './ChecklistCard';
import EmptyState from '../../components/Error/EmptyState';
// import './checklist.css'
import AuthContext from '../../context/AuthContext';
import { varFormatTime } from '../../utils/helperFunctions';
import { toast } from 'react-toastify';
import { useReactToPrint } from "react-to-print";

const StationChecklist = () => {
  const [loading, setLoading] = useState(false);
  const { permission, user } = useContext(AuthContext);
  const [showModal, setShowModal] = useState(false);
  const [searchResult, setSearchResult] = useState('');
  const [duration, setDuration] = useState('');
  const [checklistType, setChecklistType] = useState('');
  const [viewType, setViewType] = useState("list");
  const [allChecklist, setAllChecklist] = useState(null)
  const [checklistDetails, setChecklistDetails] = useState([])
  const [title, setTitle] = useState("")
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [noData, setNoData] = useState(false);
  const [isFirstTime, setIsFirsttime] = useState(true);
  const [openCategories, setOpenCategories] = useState({});
  const [locationDrop, setLocationDrop] = useState([]);
  const [selectedStation, setSelectedStation] = useState("all");
    const printRef = useRef();
    const printRef2 = useRef();

    const itemsPerPage = 10;
    const [checklistAllData , setChecklistAllData]  = useState([]);

    const handlePrint = useReactToPrint({
        contentRef: printRef,
        onBeforePrint: () =>
        new Promise((resolve) => {
            document.fonts.ready.then(() => resolve());
        }),
    });

    const handlePrint2 = useReactToPrint({
        contentRef: printRef2,
        onBeforePrint: () =>
        new Promise((resolve) => {
            document.fonts.ready.then(() => resolve());
        }),
    });
    
    let printFunction = () => {
        handlePrint()
    }

    const handleChecklistData = async (id) => {
        if (!id) return;
        setLoading(true);

        try {
            await Promise.all([
                getChecklistData(id),
                getChecklistDetails(id),
            ]);


            setTimeout(()=>{
                printFunction()
                setLoading(false)
            } , 2000)

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

  const columns = [
    {
      field: 'title', headerName: 'Title', flex: 1, minWidth: 220, valueGetter: (params) => params.row.title
    },
    {
      field: 'status', headerName: 'Status', flex: 1, minWidth: 130,
      renderCell: (params) => {
        return (
          params?.row?.status == 'active' ?
            <Chip style={{ width: '100px' }}
              color={'DarkGreen'}
              label={params.row.status.charAt(0).toUpperCase() + params.row.status.slice(1)} />
            :
            <Chip
              sx={{
                backgroundColor: '#EDE1E1',
                color: '#000000',
                cursor: 'pointer',
                width: '100px'
              }}
              label={params.row.status.charAt(0).toUpperCase() + params.row.status.slice(1)}
            />
        );
      }
    },
    {
      field: 'duration', headerName: 'Duration', flex: 1, minWidth: 200,
      renderCell: (params) => {
        return (
          <>
            {params.row.duration &&
              <Chip style={{ width: "65%" }}
                sx={{
                  borderColor: '#2B3F6C',
                  backgroundColor: '#F5F5F5',
                  color: '#2B3F6C',
                }}
                variant="outlined"
                label={params.row.duration.charAt(0).toUpperCase() + params.row.duration.slice(1)} />
            }        </>)
      }
    },
    {
      field: 'created', headerName: 'Created by', flex: 1, minWidth: 220, valueGetter: (params) => params.row.employee_full_name
    },
    {
      field: 'assigned', headerName: 'Assigned to', flex: 1, minWidth: 180, valueGetter: (params) => params.row.checklist_assign?.employee_full_name ? params.row.checklist_assign?.employee_full_name : params.row.checklist_assign?.position_name
    },
    {
      field: 'created_on', headerName: 'Created on', flex: 1, minWidth: 200, valueGetter: (params) => { return varFormatTime(params.row.created_at, user?.Time_Format) }
    },
        {
            field: 'action', headerName: 'Actions', flex: 1, minWidth: 480,
            renderCell: (params) => {
                return (
                    <Box sx={{ display: 'flex', gap: 1 }}>

                        {(
                            permission?.includes("Checklist_Auth") ||
                            user?.employee_assignment?.EA_Rank === 'AC'
                        ) && 
                            <div>
                                {(permission && permission.includes('Emp_Auth')) || params?.row?.created_by == user?.Emp_Code || user.employee_assignment.EA_Rank == 'AC' ?
                                    <Link to={`/firehouse/edit-station-checklist/${params?.row?.id}`}>
                                        <Chip
                                            variant="outlined"
                                            sx={{
                                                backgroundColor: '#EAECF0',
                                                color: '#2B3F6C',
                                                border: '1px solid #2B3F6C',
                                                cursor: 'pointer'
                                            }}
                                            avatar={<Avatar src="/images/edit.png" style={{ width: 20, height: 20, padding: 2 }} />}
                                            label={'Edit'}
                                        />
                                    </Link>
                                    :
                                    <Chip
                                            variant="outlined"
                                            sx={{
                                                backgroundColor: '#EAECF0',
                                                color: '#2B3F6C',
                                                border: '1px solid #2B3F6C',
                                            }}
                                            avatar={<Avatar src="/images/edit.png" style={{ width: 20, height: 20, padding: 2 }} />}
                                            label={'Edit'}
                                            disabled={true}
                                        />
                                }
                            </div>
                        }

                        <Chip
                            variant="outlined"
                            sx={{
                                backgroundColor: '#EAECF0',
                                color: '#2B3F6C',
                                border: '1px solid #2B3F6C',
                                cursor: 'pointer'
                            }}
                            avatar={<Avatar src="/images/eye.png" style={{ width: 28, height: 24, padding: 2 }} />}
                            label={'Checklists'}
                            onClick={() => {
                                setShowModal(true)
                                setTitle(params.row?.title)
                                getChecklistDetails(params?.row?.id)
                            }}
                        />

                        <Link to={`/firehouse/station-checklist-schedule/${params?.row?.id}`}>
                            <Chip
                                variant="outlined"
                                sx={{
                                    backgroundColor: '#BF1D2D',
                                    color: '#FFFFFF',
                                    border: '1px solid #BF1D2D',
                                    cursor: 'pointer'
                                }}
                                avatar={<Avatar src="/images/eye1.png" style={{ width: 28, height: 24, padding: 2 }} />}
                                label={'Schedule'}
                            />
                        </Link>

                        {(
                            permission?.includes("Checklist_Auth") ||
                            user?.employee_assignment?.EA_Rank === 'AC'
                        ) &&
                            <div>
                                    {params?.row?.created_by == user?.Emp_Code || user?.employee_assignment?.EA_Rank === 'AC' ?
                                        <Chip
                                            variant="outlined"
                                            sx={{
                                                backgroundColor: '#EAECF0',
                                                color: '#BF1D2D',
                                                border: '1px solid #BF1D2D',
                                                cursor: 'pointer'
                                            }}
                                            onClick= {()=>deleteChecklist(params?.row?.id)}
                                            avatar={<Avatar src="/images/delete-red.png" style={{ width: 21, height: 22, padding: 4 }} />}
                                            label={'Delete'}
                                        />
                                    :
                                        <Chip
                                            variant="outlined"
                                            sx={{
                                                backgroundColor: '#EAECF0',
                                                color: '#BF1D2D',
                                                border: '1px solid #BF1D2D',
                                            }}
                                            avatar={<Avatar src="/images/delete-red.png" style={{ width: 21, height: 22, padding: 4 }} />}
                                            label={'Delete'}
                                            disabled={true}
                                        />
                                    }
                            </div>
                        }

                        <Chip
                            variant="outlined"
                            sx={{
                                backgroundColor: '#EAECF0',
                                color: '#BF1D2D',
                                border: '1px solid #BF1D2D',
                                cursor: 'pointer',
                                padding:'6px 8px'
                            }}
                            icon={<img src="/images/print.svg" alt="print" style={{ width: 16, height: 16 }} />}
                            label={'Print'}
                            onClick={() => {
                                handleChecklistData(params?.row?.id)
                            }}
                            disabled={(permission && permission.includes('Emp_Auth') || params?.row?.created_by == user?.Emp_Code) || user?.employee_assignment?.EA_Rank === 'AC' ? false : true}
                        />
                    </Box>
                );
            },
        },
        {
            field: 'updateStatus', headerName: 'Status', flex: 1, minWidth: 80,
            renderCell: (params) => {
                return (

                    <div>
                        <Switch
                            checked={params.row.status == 'active'}
                            onChange={
                                (permission?.includes("Checklist_Auth"))
                                    ? () => updateChecklistStatus(params.row.id, params.row.status)
                                    : undefined
                            }
                            color="primary"
                        />
                    </div>
                )
            }
        }
    ]

    const getChecklist = (loader = true) => {
        const body = {
            'search': searchResult,
            'duration': duration == 'all' ? '' : duration,
            'assigned': checklistType
        }

        if (loader) {
            setLoading(true)
        }
        ApiService.post('/checklist/station-inspection', body)
            .then(( data ) => {
                if (data?.data?.length == 0 && searchResult == '' && checklistType == '' && duration == '') {
                    setNoData(true)
                } else {
                    setNoData(false)
                }
                setAllChecklist(data?.data);
                setTotalPages(Math.ceil(data?.total / data?.per_page));
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            })
    }

    const handlePageChange = (_, value) => {
        setCurrentPage(value);
    };

    const getChecklistDetails = async (id) => {
        try {
            const { data } = await ApiService.get(`/checklist/station-inspection/${id}`);
            const items = data?.data?.checklist_station_items || [];
            setChecklistDetails(items);
            setSelectedStation("all");
            // Default all categories to open
            const allOpen = items.reduce((acc, item) => {
                acc[item.category || "No category"] = true;
                return acc;
            }, {});
            setOpenCategories(allOpen);
        } catch (error) {
            console.error(error);
        }
    };

    const updateChecklistStatus = (id, currStatus) => {
        var newStatus = 'active'
        if (currStatus == 'active') {
            newStatus = 'inactive'
        }
        const body = {
            "id": id,
            "status": newStatus
        }
        ApiService.post('/checklist/update-status', body)
            .then((data) => {
                getChecklist(false)
                toast.success(data?.message)
            })
            .catch((e) => {
                setLoading(false);
            })
    }

        const deleteChecklist = (id) => {
        const body = { id }
        ApiService.post('/checklist/station-inspection/delete', body)
            .then(( data ) => {
                toast.success(data?.message)
                getChecklist()
                setLoading(false);
            })
            .catch(( error ) => {
                toast.error(error?.data?.message)
                setLoading(false);
            })
    }

    useEffect(() => {
        getChecklist()
        setIsFirsttime(false)
        getLocation()
    }, [])

    const getLocation = () => {
        ApiService.get('/checklist/location')
            .then(({ data }) => {
                const posArr = data?.data?.map((pos) => ({ label: pos.location_description, value: pos.id })) || [];
                setLocationDrop(posArr);
            })
            .catch(() => {});
    }

    const getLocationName = (id) => {
        if (!id) return "";
        const match = locationDrop.find(l => l.value == id);
        return match ? match.label : "";
    }

    useEffect(() => {
        if (!isFirstTime) {
            getChecklist(false)
        }
    }, [currentPage, searchResult, duration, checklistType])

    const getChecklistData = (id) => {
        if (id) {
            ApiService.get('/checklist/edit_details/' + id)
                .then(async ({ data }) => {
                    setChecklistAllData(data?.data || [])
                })
                .catch((e) => {
                    console.error(e || 'error')
                })
        }
    }

    const uniqueStations = [...new Set((checklistDetails || []).map(i => i.location_id).filter(Boolean))];

    const filteredChecklistDetails = selectedStation === "all"
        ? checklistDetails
        : (checklistDetails || []).filter(i => i.location_id == selectedStation);

    const groupedData = (filteredChecklistDetails || []).reduce((acc, item) => {
        const key = item.category || "No category";

        if (!acc[key]) {
            acc[key] = [];
        }

        acc[key].push(item);
        return acc;
    }, {});

    const toggleCategory = (category) => {
        setOpenCategories(prev => ({
            ...prev,
            [category]: !prev[category]
        }));
    };

    return (
        <>
            {loading ? (
                <Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
                    <CircularProgress />
                </Paper>
            )
                :
                (
                    <>
                        <Paper className="p-4 font-fam" style={{ marginTop: "1rem", minHeight: '98%' }}>
                            <Grid container className='align-items-center' gap={0} style={{ gap: "24px", marginTop: "7px" }} wrap="nowrap" >
                                <Grid item xs={12} md={3.5}>
                                    <Typography variant="h5">Station Checklist Definition</Typography>
                                </Grid>

                                {!noData &&
                                    <>
                                        {(permission.includes("Checklist_Auth")) &&
                                            <Grid item xs={12} sm={12} md={1.5}>
                                                <div>
                                                    <Link to="/firehouse/add-station-checklist">
                                                        <ButtonTheme type='submit' variant="filled" color='primary'>
                                                            Add New
                                                        </ButtonTheme>
                                                    </Link>
                                                </div>
                                            </Grid>
                                        }

                                        <Grid items xs={12} sm={12} md={2} className='font-fam'>
                                            <TextField
                                                select size='small'
                                                placeholder='Duration'
                                                className='mt-0 w-100' color='secondary' variant="outlined"
                                                label='Duration'
                                                value={duration}
                                                onChange={(e) => setDuration(e.target.value)}
                                                InputProps={{
                                                    sx: {
                                                        height: '48px',
                                                        fontSize: '14px'
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    sx: {
                                                        marginTop: '4px',
                                                        fontSize: '14px'
                                                    },
                                                }}
                                            >
                                                <MenuItem value={"all"} key={""} className='font-fam'>{"All"} </MenuItem>
                                                <MenuItem value={"daily"} key={"daily"} className='font-fam'>{"Daily"} </MenuItem>
                                                <MenuItem value={"everyotherday"} key={"everyotherday"} className='font-fam'>{"Every Other Day"} </MenuItem>
                                                <MenuItem value={"weekly"} key={"weekly"} className='font-fam'>{"Weekly"} </MenuItem>
                                                <MenuItem value={"biweekly"} key={"biweekly"} className='font-fam'>{"Bi-weekly"} </MenuItem>
                                                <MenuItem value={"monthly"} key={"monthly"} className='font-fam'>{"Monthly"} </MenuItem>
                                            </TextField>
                                        </Grid>

                                        <Grid items xs={12} sm={12} md={2} className='font-fam'>
                                            <TextField
                                                select size='small'
                                                placeholder='Type'
                                                className='mt-0 w-100' color='secondary' variant="outlined"
                                                label='Type'
                                                value={checklistType}
                                                onChange={(e) => setChecklistType(e.target.value)}
                                                InputProps={{
                                                    sx: {
                                                        height: '48px',
                                                        fontSize: '14px'
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    sx: {
                                                        marginTop: '4px',
                                                        fontSize: '14px'
                                                    },
                                                }}
                                            >
                                                <MenuItem value={"all"} key={"all"} className='font-fam'>{"All"} </MenuItem>
                                                <MenuItem value={"myChecklist"} key={"myChecklist"} className='font-fam'>{"My checklist"} </MenuItem>
                                                <MenuItem value={"otherChecklist"} key={"otherChecklist"} className='font-fam'>{"Other checklist"} </MenuItem>
                                            </TextField>
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={2}>
                                            <TextField
                                                variant="outlined"
                                                placeholder="Search from title"
                                                onChange={(e) => setSearchResult(e.target.value)}
                                                className="w-100"
                                                value={searchResult}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton>
                                                                <SearchIcon />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                    sx: {
                                                        height: '48px',
                                                        fontSize: '14px',
                                                        marginRight: '10px',
                                                    },
                                                }}
                                            />
                                        </Grid>
                                    </>
                                }
                            </Grid>

                            {(allChecklist && allChecklist.length == 0) && (checklistType != '' || searchResult.length > 0 || duration != '') ?
                                <div className='d-flex align-items-center' style={{ height: 550 }}>
                                    <EmptyState />
                                </div>

                                :
                                !allChecklist || allChecklist.length == 0 ?
                                    <Box>
                                        <div className='mt-2' style={{ color: '#555555' }}>
                                            No Station Checklist available right now.
                                        </div>

                                        <div className='inner-box d-flex flex-column align-items-center justify-content-center' style={{ height: 530 }}>
                                            <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                                            <span className='mt-4' style={{ color: '#555555' }}>
                                                <Link to="/firehouse/add-station-checklist">
                                                    {(permission.includes("Checklist_Auth")) &&
                                                        <ButtonTheme type='submit' variant="filled" color='primary'>
                                                            Add Station Checklist 
                                                        </ButtonTheme>
                                                    }
                                                </Link>
                                            </span>
                                        </div>
                                    </Box>
                                    :
                                    <>
                                        {viewType == "list" ?
                                            <div className='mt-4'>
                                                <MyTable
                                                    rows={allChecklist}
                                                    columns={columns}
                                                    perPage={10}
                                                    rowCount={allChecklist.length}
                                                    checkboxSelection={false}
                                                    hideFooter={true}
                                                />
                                            </div>
                                            :
                                            <>
                                                {/* {allChecklist.map((item) => (
                                                    <ChecklistCard data={item} setShowModal={setShowModal} getChecklistDetails={getChecklistDetails} setTitle={setTitle} getChecklist={getChecklist} />
                                                ))} */}
                                            </>
                                        }
                                        <Pagination
                                            count={totalPages}
                                            page={currentPage}
                                            onChange={handlePageChange}
                                            color="primary"
                                            className="mt-4 d-flex"
                                            style={{ justifyContent: 'end' }}
                                        />
                                    </>
                            }
                        </Paper >
                    </>
                )}

            {/* Checklist Pop-Up View */}
            <div className='font-fam' ref={printRef2}>
                <Modal show={showModal} size="lg"
                    onHide={() => {
                        setShowModal(false)
                        setChecklistDetails([])
                    }}>

                    <Modal.Header
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                        >
                        <Modal.Title>Checklist Details - {title}</Modal.Title>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <ButtonTheme color='primary' onClick={handlePrint2}>
                                Print
                            </ButtonTheme>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={()=> {
                                    setShowModal(false) 
                                    setChecklistDetails([])
                                }}
                            ></button>
                        </div>
                    </Modal.Header>


                    <Modal.Body style={{ padding: 22 }}>
                        <Grid item xs={12} ref={printRef2}>
                            <h4 style={{ marginBottom: 15, fontWeight: 600 }} className="print-header">
                                Checklist Items - {title}
                            </h4>

                            {checklistDetails && checklistDetails.length > 0 && uniqueStations.length > 0 && (
                                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16, overflowX: 'auto' }}>
                                    <div
                                        onClick={() => setSelectedStation("all")}
                                        style={{
                                            cursor: 'pointer',
                                            padding: '8px 16px',
                                            borderRadius: '999px',
                                            fontSize: 13,
                                            fontFamily: 'karla, sans-serif',
                                            userSelect: 'none',
                                            whiteSpace: 'nowrap',
                                            backgroundColor: selectedStation === "all" ? "#BF1D2D" : "#f0f0f0",
                                            color: selectedStation === "all" ? "#fff" : "#555",
                                            transition: 'all 0.2s'
                                        }}
                                    >
                                        All
                                    </div>
                                    {uniqueStations.map(stationId => (
                                        <div
                                            key={stationId}
                                            onClick={() => setSelectedStation(stationId)}
                                            style={{
                                                cursor: 'pointer',
                                                padding: '8px 16px',
                                                borderRadius: '999px',
                                                fontSize: 13,
                                                fontFamily: 'karla, sans-serif',
                                                userSelect: 'none',
                                                whiteSpace: 'nowrap',
                                                backgroundColor: selectedStation == stationId ? "#BF1D2D" : "#f0f0f0",
                                                color: selectedStation == stationId ? "#fff" : "#555",
                                                transition: 'all 0.2s'
                                            }}
                                        >
                                            {getLocationName(stationId) || 'Unknown'}
                                        </div>
                                    ))}
                                </div>
                            )}

                            {checklistDetails && checklistDetails.length > 0 ? (
                                <div className='font-fam mt-2'>
                                    {Object.entries(groupedData).map(([category, items], index) => {
                                        const isOpen = openCategories[category];

                                        return (
                                            <div key={category} style={{ marginBottom: 16 }}>

                                                {/* Category Header */}
                                                <div
                                                    onClick={() => toggleCategory(category)}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer',
                                                        padding: '8px 4px',
                                                        borderBottom: '1px solid #e0e0e0',
                                                        userSelect: 'none'
                                                    }}
                                                >
                                                    <span style={{
                                                        marginRight: 10,
                                                        fontSize: 10,
                                                        color: '#999',
                                                        transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                                                        transition: 'transform 0.2s ease',
                                                        display: 'inline-block'
                                                    }}>
                                                        ▶
                                                    </span>
                                                    <span style={{
                                                        minWidth: 22, height: 22, borderRadius: '50%',
                                                        background: '#BF1D2D', color: '#fff',
                                                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                                        fontSize: 11, fontWeight: 700, marginRight: 10, flexShrink: 0
                                                    }}>
                                                        {index + 1}
                                                    </span>
                                                    <span style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>
                                                        {category}
                                                    </span>
                                                    <span style={{
                                                        marginLeft: 8, fontSize: 12, color: '#aaa', fontWeight: 400
                                                    }}>
                                                        ({items.length} {items.length === 1 ? 'item' : 'items'})
                                                    </span>
                                                </div>

                                                {/* Child Items */}
                                                <div
                                                    style={{
                                                        maxHeight: isOpen ? 1000 : 0,
                                                        overflow: 'hidden',
                                                        transition: 'max-height 0.3s ease'
                                                    }}
                                                >
                                                    <div style={{
                                                        marginLeft: 16,
                                                        borderLeft: '2px solid #e0e0e0',
                                                        paddingLeft: 16,
                                                        marginTop: 8
                                                    }}>
                                                        {items.map((item, i) => (
                                                            <div
                                                                key={item.id || i}
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'flex-start',
                                                                    gap: 10,
                                                                    padding: '8px 0',
                                                                    borderBottom: i < items.length - 1 ? '1px solid #f0f0f0' : 'none',
                                                                    position: 'relative'
                                                                }}
                                                            >
                                                                <div style={{
                                                                    position: 'absolute',
                                                                    left: -16,
                                                                    top: 16,
                                                                    width: 12,
                                                                    height: 0,
                                                                    borderTop: '2px solid #e0e0e0'
                                                                }} />

                                                                <div style={{
                                                                    width: 6,
                                                                    height: 6,
                                                                    borderRadius: '50%',
                                                                    background: '#BF1D2D',
                                                                    marginTop: 5,
                                                                    flexShrink: 0
                                                                }} />

                                                                <div style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    width: '100%',
                                                                    gap: 10
                                                                }}>
                                                                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 4 }}>
                                                                        <p style={{
                                                                            margin: 0,
                                                                            fontSize: 13,
                                                                            color: '#555',
                                                                            lineHeight: 1.5
                                                                        }}>
                                                                            {item.description || (
                                                                                <span style={{ color: '#ccc', fontStyle: 'italic' }}>
                                                                                    No description
                                                                                </span>
                                                                            )}
                                                                        </p>
                                                                        {item.location_id && (
                                                                            <span style={{ fontSize: 12, color: '#2B3F6C', fontWeight: 500 }}>
                                                                                Parent Station: <span style={{ fontWeight: 400, color: '#555' }}>{getLocationName(item.location_id) || '—'}</span>
                                                                            </span>
                                                                        )}
                                                                    </div>

                                                                    <div style={{ display: 'flex', gap: 6 }}>
                                                                        <Chip
                                                                            variant="outlined"
                                                                            size="small"
                                                                            sx={{
                                                                                backgroundColor: '#DDDDDD00',
                                                                                color: '#BF1D2D',
                                                                                border: '1px solid #BF1D2D'
                                                                            }}
                                                                            avatar={
                                                                                <Avatar
                                                                                    src="/images/red-cross.png"
                                                                                    style={{ width: 24, height: 24, padding: 4 }}
                                                                                />
                                                                            }
                                                                            label={'No'}
                                                                        />

                                                                        <Chip
                                                                            variant="outlined"
                                                                            size="small"
                                                                            sx={{
                                                                                backgroundColor: '#DDDDDD00',
                                                                                color: '#2B3F6C',
                                                                                border: '1px solid #2B3F6C80'
                                                                            }}
                                                                            avatar={
                                                                                <Avatar
                                                                                    src="/images/check1.png"
                                                                                    style={{ width: 24, height: 24, padding: 5 }}
                                                                                />
                                                                            }
                                                                            label={'Yes'}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div style={{ color: '#999', textAlign: 'center', padding: '30px 0' }}>
                                    No checklist items found.
                                </div>
                            )}
                        </Grid>
                    </Modal.Body>
                </Modal>
            </div>

            <div ref={printRef} className='print-data-new-data'>
                <div>
                    <div className='d-flex align-items-center justify-content-between print-header'>
                        Firehouse247
                        <div className='text-center'>
                            <h4>Checklist Data Report</h4>
                        </div>
                        <img src='/images/black-logo.png' style={{ width: 60, height: 60 }} />
                    </div>

                    <div className='mt-2'>
                        <h5>Checklist Definition</h5>
                        <div className='font-fam p-3 mt-2' 
                        style={{display:'flex' , flexDirection:'column' , gap:'6px' , border:'1px solid #cccccc' , borderRadius:'12px' }}>
                            <div>
                                <p style={{marginBottom:'0px'}}>Title : <strong>{checklistAllData?.title}</strong></p>
                            </div>
                            <div>
                                <p style={{marginBottom:'0px' , paddingTop:'6px'}}>Status : <strong>{checklistAllData?.status}</strong></p>
                            </div>
                            <div>
                                <p style={{marginBottom:'0px', paddingTop:'6px'}}>Duration : <strong>{checklistAllData?.duration}</strong></p>
                            </div>
                            <div>
                                <p style={{marginBottom:'0px' , paddingTop:'6px'}}>Day : <strong>{checklistAllData?.day}</strong></p>
                            </div>
                            <div>
                                <p style={{marginBottom:'0px' , paddingTop:'6px'}}>Time : <strong>{checklistAllData?.time}</strong></p>
                            </div>
                            <div>
                                <p style={{marginBottom:'0px' , paddingTop:'6px'}}>Assigned by : <strong>{checklistAllData?.employee_full_name}</strong></p>
                            </div>
                            <div>
                                <p style={{marginBottom:'0px' , paddingTop:'6px'}}>Assigned to : <strong>{checklistAllData?.checklist_assign?.employee_full_name}</strong></p>
                            </div>
                            <div>
                                <p style={{ marginBottom: "0px" , paddingTop:'6px'}}>
                                    Notify to :
                                    <strong>
                                        {checklistAllData?.notify
                                            ?.map(
                                                (name) =>
                                                    ` ${name.notify_employee_first_name} ${name.notify_employee_last_name}`
                                            )
                                            .join(", ")}
                                    </strong>
                                </p>
                            </div>
                            <div>
                                <p style={{marginBottom:'0px' , paddingTop:'6px'}}>Notify Checklist Update to : <strong>{checklistAllData?.notify_checklist_update_to_name}</strong></p>
                            </div>
                        </div>
                    </div>

                    {checklistAllData?.description &&
                        <div className='mt-4 page-break-never'>
                            <h5>Checklist Description</h5>
                            <div className='font-fam p-3 mt-2' style={{display:'flex' , flexDirection:'column' , gap:'6px' , border:'1px solid #cccccc' , borderRadius:'12px' }}>
                                {checklistAllData?.description}
                            </div>
                        </div>
                    }

                    <div className='mt-4'>
                        <h5>Checklist</h5>
                        <div style={{display:'flex' , flexDirection:'column' }}>
                            {checklistDetails && checklistDetails.map((item) => (
                                <div style={{display:'flex' , border:'1px solid #e0e0e0' , borderRadius:'10px' , justifyContent:'space-between' , padding:'0px 12px'}} className='page-break-never shows-data-side'>
                                    <div style={{marginTop:'10px'}}>
                                        <p>{item?.category}</p>
                                    </div>
                                    <div style={{marginTop:'10px'}}>
                                        <p>Parent Station : <span>{getLocationName(item.location_id) || '—'}</span></p>
                                    </div>
                                    <div style={{marginTop:'10px'}}>
                                        {item.description ?
                                            <p>Description : <span> {item.description}</span></p> :
                                            <p>Description : <span style={{color:'#cccccc'}}>No description</span>
                                            </p>
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    </div>
            </div>
        </>
    )
}
export default StationChecklist;
